/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { KonfiguracjaDto } from '../models/konfiguracja-dto';
import { KonfiguracjaOsobyDto } from '../models/konfiguracja-osoby-dto';
import { KonfiguracjaPoleDto } from '../models/konfiguracja-pole-dto';
import { RodzicDto } from '../models/rodzic-dto';
import { OsobaPelnaDto } from '../models/osoba-pelna-dto';

/**
 * Osoba Controller
 */
@Injectable({
  providedIn: 'root',
})
class OsobaControllerService extends __BaseService {
  static readonly postZmienZdjecieProfiloweUsingPOSTPath = '/awatar';
  static readonly weryfikujAdresEmailUsingPOSTPath = '/email/weryfikacja/{token}';
  static readonly inicjujWeryfikacjeAdresuEmailUsingPOSTPath = '/email/wyslijLinkWeryfikacyjny/{email}';
  static readonly inicjujWeryfikacjeAdresuEmailRodzicaUsingPOSTPath = '/email/wyslijLinkWeryfikacyjnyRodzica/{rodzicId}';
  static readonly zmienImieUsingPUTPath = '/imie';
  static readonly potwierdzOdebranieUsingPOSTPath = '/komunikat/dialog/{komunikatId}';
  static readonly getKonfiguracjaUsingGETPath = '/konfiguracja';
  static readonly weryfikujUstawGlownyAdresuEmailUsingPOSTPath = '/konto/email/glowny/weryfikacja/{token}';
  static readonly inicjujUstawGlownyEmailUsingPOSTPath = '/konto/email/glowny/{emailId}';
  static readonly inicjujZmianeAdresuOpiekunaUsingPOSTPath = '/konto/email/opiekuna';
  static readonly weryfikujUsuniecieAdresuEmailUsingPOSTPath = '/konto/email/usun/weryfikacja/{token}';
  static readonly inicjujUsuniecieAdresuEmailUsingPOSTPath = '/konto/email/{emailId}';
  static readonly getKontoKonfiguracjaUsingGETPath = '/konto/konfiguracja';
  static readonly postDodajPoleKonfiguracjaOsobyUsingPOSTPath = '/konto/konfiguracja/pole';
  static readonly deleteUsunjPoleKonfiguracjaRoliUsingPOSTPath = '/konto/konfiguracja/pole/usun';
  static readonly weryfikujOdpiecieOpiekunaOdUczniaUsingPOSTPath = '/konto/odepnijOpiekuna/weryfikacja/{token}';
  static readonly inicjujUsuniecieAdresuEmailOpiekunaUsingPOSTPath = '/konto/opiekun/email/{emailId}';
  static readonly getLiczbaNieprzeczytanychWiaodmosciUsingGETPath = '/konto/problemy/wiadomosci/nieprzeczytane';
  static readonly getRodziceUsingGETPath = '/konto/rodzice';
  static readonly getHashMergaKontaUsingGETPath = '/merge';
  static readonly postHashMergeKontaUsingPOSTPath = '/merge';
  static readonly zmienNazwiskoUsingPUTPath = '/nazwisko';
  static readonly getMessageUsingGETPath = '/pinger/message';
  static readonly getUserPrincipalUsingGETPath = '/pinger/ping';
  static readonly getOpisPowoduDezaktywacjiUsingGETPath = '/powod/opis/{powod}';
  static readonly czySaProblemyZMailemUsingGETPath = '/problemyZMailem';
  static readonly getUserPrincipalUsingGET1Path = '/userPrincipal';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * postZmienZdjecieProfilowe
   * @param file file
   * @return OK
   */
  postZmienZdjecieProfiloweUsingPOSTResponse(file: Blob): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (file != null) { __formData.append('file', file as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/awatar`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * postZmienZdjecieProfilowe
   * @param file file
   * @return OK
   */
  postZmienZdjecieProfiloweUsingPOST(file: Blob): __Observable<string> {
    return this.postZmienZdjecieProfiloweUsingPOSTResponse(file).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * weryfikujAdresEmail
   * @param token token
   */
  weryfikujAdresEmailUsingPOSTResponse(token: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/email/weryfikacja/${encodeURIComponent(token)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * weryfikujAdresEmail
   * @param token token
   */
  weryfikujAdresEmailUsingPOST(token: string): __Observable<null> {
    return this.weryfikujAdresEmailUsingPOSTResponse(token).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * inicjujWeryfikacjeAdresuEmail
   * @param email email
   */
  inicjujWeryfikacjeAdresuEmailUsingPOSTResponse(email: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/email/wyslijLinkWeryfikacyjny/${encodeURIComponent(email)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * inicjujWeryfikacjeAdresuEmail
   * @param email email
   */
  inicjujWeryfikacjeAdresuEmailUsingPOST(email: string): __Observable<null> {
    return this.inicjujWeryfikacjeAdresuEmailUsingPOSTResponse(email).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * inicjujWeryfikacjeAdresuEmailRodzica
   * @param rodzicId rodzicId
   */
  inicjujWeryfikacjeAdresuEmailRodzicaUsingPOSTResponse(rodzicId: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/email/wyslijLinkWeryfikacyjnyRodzica/${encodeURIComponent(rodzicId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * inicjujWeryfikacjeAdresuEmailRodzica
   * @param rodzicId rodzicId
   */
  inicjujWeryfikacjeAdresuEmailRodzicaUsingPOST(rodzicId: number): __Observable<null> {
    return this.inicjujWeryfikacjeAdresuEmailRodzicaUsingPOSTResponse(rodzicId).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * zmienImie
   * @param imie imie
   */
  zmienImieUsingPUTResponse(imie?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = imie;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/imie`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * zmienImie
   * @param imie imie
   */
  zmienImieUsingPUT(imie?: string): __Observable<null> {
    return this.zmienImieUsingPUTResponse(imie).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * potwierdzOdebranie
   * @param komunikatId komunikatId
   */
  potwierdzOdebranieUsingPOSTResponse(komunikatId: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = komunikatId;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/komunikat/dialog/${encodeURIComponent(komunikatId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * potwierdzOdebranie
   * @param komunikatId komunikatId
   */
  potwierdzOdebranieUsingPOST(komunikatId: number): __Observable<null> {
    return this.potwierdzOdebranieUsingPOSTResponse(komunikatId).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * getKonfiguracja
   * @return OK
   */
  getKonfiguracjaUsingGETResponse(): __Observable<__StrictHttpResponse<KonfiguracjaDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/konfiguracja`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KonfiguracjaDto>;
      })
    );
  }
  /**
   * getKonfiguracja
   * @return OK
   */
  getKonfiguracjaUsingGET(): __Observable<KonfiguracjaDto> {
    return this.getKonfiguracjaUsingGETResponse().pipe(
      __map(_r => _r.body as KonfiguracjaDto)
    );
  }

  /**
   * weryfikujUstawGlownyAdresuEmail
   * @param token token
   */
  weryfikujUstawGlownyAdresuEmailUsingPOSTResponse(token: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/konto/email/glowny/weryfikacja/${encodeURIComponent(token)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * weryfikujUstawGlownyAdresuEmail
   * @param token token
   */
  weryfikujUstawGlownyAdresuEmailUsingPOST(token: string): __Observable<null> {
    return this.weryfikujUstawGlownyAdresuEmailUsingPOSTResponse(token).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * inicjujUstawGlownyEmail
   * @param emailId emailId
   */
  inicjujUstawGlownyEmailUsingPOSTResponse(emailId: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/konto/email/glowny/${encodeURIComponent(emailId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * inicjujUstawGlownyEmail
   * @param emailId emailId
   */
  inicjujUstawGlownyEmailUsingPOST(emailId: number): __Observable<null> {
    return this.inicjujUstawGlownyEmailUsingPOSTResponse(emailId).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * inicjujZmianeAdresuOpiekuna
   * @param nowyEmail nowyEmail
   */
  inicjujZmianeAdresuOpiekunaUsingPOSTResponse(nowyEmail: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = nowyEmail;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/konto/email/opiekuna`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * inicjujZmianeAdresuOpiekuna
   * @param nowyEmail nowyEmail
   */
  inicjujZmianeAdresuOpiekunaUsingPOST(nowyEmail: string): __Observable<null> {
    return this.inicjujZmianeAdresuOpiekunaUsingPOSTResponse(nowyEmail).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * weryfikujUsuniecieAdresuEmail
   * @param token token
   */
  weryfikujUsuniecieAdresuEmailUsingPOSTResponse(token: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/konto/email/usun/weryfikacja/${encodeURIComponent(token)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * weryfikujUsuniecieAdresuEmail
   * @param token token
   */
  weryfikujUsuniecieAdresuEmailUsingPOST(token: string): __Observable<null> {
    return this.weryfikujUsuniecieAdresuEmailUsingPOSTResponse(token).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * inicjujUsuniecieAdresuEmail
   * @param emailId emailId
   */
  inicjujUsuniecieAdresuEmailUsingPOSTResponse(emailId: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/konto/email/${encodeURIComponent(emailId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * inicjujUsuniecieAdresuEmail
   * @param emailId emailId
   */
  inicjujUsuniecieAdresuEmailUsingPOST(emailId: number): __Observable<null> {
    return this.inicjujUsuniecieAdresuEmailUsingPOSTResponse(emailId).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * getKontoKonfiguracja
   * @return OK
   */
  getKontoKonfiguracjaUsingGETResponse(): __Observable<__StrictHttpResponse<KonfiguracjaOsobyDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/konto/konfiguracja`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KonfiguracjaOsobyDto>;
      })
    );
  }
  /**
   * getKontoKonfiguracja
   * @return OK
   */
  getKontoKonfiguracjaUsingGET(): __Observable<KonfiguracjaOsobyDto> {
    return this.getKontoKonfiguracjaUsingGETResponse().pipe(
      __map(_r => _r.body as KonfiguracjaOsobyDto)
    );
  }

  /**
   * postDodajPoleKonfiguracjaOsoby
   * @param dto dto
   * @return OK
   */
  postDodajPoleKonfiguracjaOsobyUsingPOSTResponse(dto: KonfiguracjaPoleDto): __Observable<__StrictHttpResponse<KonfiguracjaOsobyDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = dto;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/konto/konfiguracja/pole`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KonfiguracjaOsobyDto>;
      })
    );
  }
  /**
   * postDodajPoleKonfiguracjaOsoby
   * @param dto dto
   * @return OK
   */
  postDodajPoleKonfiguracjaOsobyUsingPOST(dto: KonfiguracjaPoleDto): __Observable<KonfiguracjaOsobyDto> {
    return this.postDodajPoleKonfiguracjaOsobyUsingPOSTResponse(dto).pipe(
      __map(_r => _r.body as KonfiguracjaOsobyDto)
    );
  }

  /**
   * deleteUsunjPoleKonfiguracjaRoli
   * @param klucz klucz
   * @return OK
   */
  deleteUsunjPoleKonfiguracjaRoliUsingPOSTResponse(klucz: string): __Observable<__StrictHttpResponse<KonfiguracjaOsobyDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = klucz;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/konto/konfiguracja/pole/usun`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<KonfiguracjaOsobyDto>;
      })
    );
  }
  /**
   * deleteUsunjPoleKonfiguracjaRoli
   * @param klucz klucz
   * @return OK
   */
  deleteUsunjPoleKonfiguracjaRoliUsingPOST(klucz: string): __Observable<KonfiguracjaOsobyDto> {
    return this.deleteUsunjPoleKonfiguracjaRoliUsingPOSTResponse(klucz).pipe(
      __map(_r => _r.body as KonfiguracjaOsobyDto)
    );
  }

  /**
   * weryfikujOdpiecieOpiekunaOdUcznia
   * @param token token
   */
  weryfikujOdpiecieOpiekunaOdUczniaUsingPOSTResponse(token: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/konto/odepnijOpiekuna/weryfikacja/${encodeURIComponent(token)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * weryfikujOdpiecieOpiekunaOdUcznia
   * @param token token
   */
  weryfikujOdpiecieOpiekunaOdUczniaUsingPOST(token: string): __Observable<null> {
    return this.weryfikujOdpiecieOpiekunaOdUczniaUsingPOSTResponse(token).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * inicjujUsuniecieAdresuEmailOpiekuna
   * @param emailId emailId
   */
  inicjujUsuniecieAdresuEmailOpiekunaUsingPOSTResponse(emailId: number): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/konto/opiekun/email/${encodeURIComponent(emailId)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * inicjujUsuniecieAdresuEmailOpiekuna
   * @param emailId emailId
   */
  inicjujUsuniecieAdresuEmailOpiekunaUsingPOST(emailId: number): __Observable<null> {
    return this.inicjujUsuniecieAdresuEmailOpiekunaUsingPOSTResponse(emailId).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * getLiczbaNieprzeczytanychWiaodmosci
   * @return OK
   */
  getLiczbaNieprzeczytanychWiaodmosciUsingGETResponse(): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/konto/problemy/wiadomosci/nieprzeczytane`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: parseFloat((_r as HttpResponse<any>).body as string) }) as __StrictHttpResponse<number>
      })
    );
  }
  /**
   * getLiczbaNieprzeczytanychWiaodmosci
   * @return OK
   */
  getLiczbaNieprzeczytanychWiaodmosciUsingGET(): __Observable<number> {
    return this.getLiczbaNieprzeczytanychWiaodmosciUsingGETResponse().pipe(
      __map(_r => _r.body as number)
    );
  }

  /**
   * getRodzice
   * @return OK
   */
  getRodziceUsingGETResponse(): __Observable<__StrictHttpResponse<Array<RodzicDto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/konto/rodzice`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<RodzicDto>>;
      })
    );
  }
  /**
   * getRodzice
   * @return OK
   */
  getRodziceUsingGET(): __Observable<Array<RodzicDto>> {
    return this.getRodziceUsingGETResponse().pipe(
      __map(_r => _r.body as Array<RodzicDto>)
    );
  }

  /**
   * getHashMergaKonta
   * @return OK
   */
  getHashMergaKontaUsingGETResponse(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/merge`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * getHashMergaKonta
   * @return OK
   */
  getHashMergaKontaUsingGET(): __Observable<string> {
    return this.getHashMergaKontaUsingGETResponse().pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * postHashMergeKonta
   * @param hash hash
   * @return OK
   */
  postHashMergeKontaUsingPOSTResponse(hash: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = hash;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/merge`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * postHashMergeKonta
   * @param hash hash
   * @return OK
   */
  postHashMergeKontaUsingPOST(hash: string): __Observable<string> {
    return this.postHashMergeKontaUsingPOSTResponse(hash).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * zmienNazwisko
   * @param nazwisko nazwisko
   */
  zmienNazwiskoUsingPUTResponse(nazwisko?: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = nazwisko;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/nazwisko`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * zmienNazwisko
   * @param nazwisko nazwisko
   */
  zmienNazwiskoUsingPUT(nazwisko?: string): __Observable<null> {
    return this.zmienNazwiskoUsingPUTResponse(nazwisko).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * getMessage
   * @return OK
   */
  getMessageUsingGETResponse(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/pinger/message`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * getMessage
   * @return OK
   */
  getMessageUsingGET(): __Observable<string> {
    return this.getMessageUsingGETResponse().pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * getUserPrincipal
   * @return OK
   */
  getUserPrincipalUsingGETResponse(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/pinger/ping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * getUserPrincipal
   * @return OK
   */
  getUserPrincipalUsingGET(): __Observable<string> {
    return this.getUserPrincipalUsingGETResponse().pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * getOpisPowoduDezaktywacji
   * @param powod powod
   * @return OK
   */
  getOpisPowoduDezaktywacjiUsingGETResponse(powod: 'GMINA_NIE_PRZESLALA_ZGLOSZENIA' | 'NIEUKONCZONE_SZKOLENIE' | 'BRAK_AKTYWNOSCI' | 'BRAK_CHECI_KONTYNUACJI_WYRAZONY_W_ANKIECIE' | 'ZNIKOME_ZAINTERESOWANIE_UCZNIOW_ZGLOSZONE_PRZEZ_NAUCZYCIELA' | 'ZABLOKOWANE_AUTOMATYCZNIE'): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (powod != null) __params = __params.set('powod', powod.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/powod/opis/${encodeURIComponent(powod)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * getOpisPowoduDezaktywacji
   * @param powod powod
   * @return OK
   */
  getOpisPowoduDezaktywacjiUsingGET(powod: 'GMINA_NIE_PRZESLALA_ZGLOSZENIA' | 'NIEUKONCZONE_SZKOLENIE' | 'BRAK_AKTYWNOSCI' | 'BRAK_CHECI_KONTYNUACJI_WYRAZONY_W_ANKIECIE' | 'ZNIKOME_ZAINTERESOWANIE_UCZNIOW_ZGLOSZONE_PRZEZ_NAUCZYCIELA' | 'ZABLOKOWANE_AUTOMATYCZNIE'): __Observable<string> {
    return this.getOpisPowoduDezaktywacjiUsingGETResponse(powod).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * czySaProblemyZMailem
   * @return OK
   */
  czySaProblemyZMailemUsingGETResponse(): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/problemyZMailem`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * czySaProblemyZMailem
   * @return OK
   */
  czySaProblemyZMailemUsingGET(): __Observable<boolean> {
    return this.czySaProblemyZMailemUsingGETResponse().pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * getUserPrincipal
   * @param name undefined
   * @return OK
   */
  getUserPrincipalUsingGET1Response(name?: string): __Observable<__StrictHttpResponse<OsobaPelnaDto>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (name != null) __params = __params.set('name', name.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/userPrincipal`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<OsobaPelnaDto>;
      })
    );
  }
  /**
   * getUserPrincipal
   * @param name undefined
   * @return OK
   */
  getUserPrincipalUsingGET1(name?: string): __Observable<OsobaPelnaDto> {
    return this.getUserPrincipalUsingGET1Response(name).pipe(
      __map(_r => _r.body as OsobaPelnaDto)
    );
  }
}

module OsobaControllerService {
}

export { OsobaControllerService }
